import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';

import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import { SiteMerchantTypesResponse } from '@app/api/marketplace/models';
import { TableDataSource } from '@shared/components/table/table-data-source.model';
import { PageRequest } from '@shared/interfaces/page-request.interface';
import { DialogService } from '@shared/services/dialog.service';

import { MerchantRejectModalComponent } from '../../modals/merchant-reject-modal/merchant-reject-modal.component';
import {
  MerchantApprovalsActions,
  MerchantApprovalsSelectors,
} from '../../store/merchant-approvals.slice';

@Component({
  selector: 'app-merchant-approvals',
  templateUrl: './merchant-approvals.component.html',
  styleUrls: ['./merchant-approvals.component.scss'],
})
export class MerchantApprovalsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource = new TableDataSource<PageRequest, SiteMerchantTypesResponse>(
    this.store
  );
  filter?: PageRequest;

  subs = new SubSink();

  constructor(private store: Store, private dialogService: DialogService) {}

  ngOnInit(): void {
    this.store.dispatch(
      MerchantApprovalsActions.getMerchantTypeRequests.trigger()
    );
  }
  ngAfterViewInit(): void {
    this.dataSource.init(
      this.paginator,
      this.sort,
      undefined,
      [
        'checkboxes',
        'companyName',
        'taxNumber',
        'siteName',
        'merchantType',
        'licenseNumber',
        'actions',
      ],
      (_filter, store: Store) =>
        store.dispatch(
          MerchantApprovalsActions.getMerchantTypeRequests.trigger()
        ),
      (filter, store: Store) =>
        store.dispatch(
          MerchantApprovalsActions.updateFilter.trigger({ filter })
        ),
      (store: Store) => store.select(MerchantApprovalsSelectors.selectData),
      (store: Store) =>
        store.select(MerchantApprovalsSelectors.selectDataLoading)
    );
  }

  approveItems(approval: boolean, rowId?: string) {
    const multiple = rowId
      ? false
      : this.dataSource.selection.selected.length > 1;
    const uuidList = [
      ...(rowId
        ? [rowId]
        : this.dataSource.selection.selected.map((item) => item.id!)),
    ];
    if (approval) {
      this.dialogService.confirm(
        'MERCHANT_APPROVALS.MODAL.APPROVE_TITLE',
        'MERCHANT_APPROVALS.MODAL.' +
          (multiple ? 'APPROVE_MORE_TEXT' : 'APPROVE_TEXT'),
        () => {
          this.store.dispatch(
            MerchantApprovalsActions.updateMerchantTypeStatus.trigger({
              request: {
                newStatus: 'ACCEPTED',
                uuidList: uuidList,
              },
            })
          );
        }
      );
    } else {
      const dialogConfig: MatDialogConfig = {
        data: {
          approval: approval,
          multiple: multiple,
        },
        minHeight: 'unset',
        minWidth: '500px',
      };
      this.subs.sink = this.dialogService
        .openDialog(MerchantRejectModalComponent, dialogConfig)
        .afterClosed()
        .subscribe((result: { agree: boolean; comment: string }) => {
          if (result.agree) {
            this.store.dispatch(
              MerchantApprovalsActions.updateMerchantTypeStatus.trigger({
                request: {
                  comment: result.comment ?? '',
                  newStatus: 'REJECTED',
                  uuidList: uuidList,
                },
              })
            );
          }
        });
    }
  }
}
